<template>
  <div>
    <b-overlay :show="isLoading" rounded="sm">
      <treeselect
        v-model="selectedValues"
        :multiple="true"
        :options="values"
        :clearable="false"
        @input="changed"
        value-consists-of="LEAF_PRIORITY"
      ></treeselect>
    </b-overlay>
  </div>
</template>

<script>
import _ from 'lodash';
import http from '@/mixins/http';

export default {
  name: 'FilterBrand',
  props: {
    filter: {
      type: Object,
      required: true,
    },
    selectedCubeId: {
      type: Number,
      required: true,
    },
  },
  mixins: [http],
  mounted() {
    this.getBrands();
    if (this.filter.options.length) {
      this.selectedValues = _.map(this.filter.options, option => {
        return option.value;
      });
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        if (this.filter.options.length) {
          this.selectedValues = _.map(this.filter.options, option => {
            return option.value;
          });
        }
      },
    },
  },
  data() {
    return {
      isLoading: false,
      selectedValues: [],
      values: [],
    };
  },
  methods: {
    getBrands() {
      this.axios.get('api/dataGrabber/brands').then(resp => {
        if (resp.data) {
          this.values = _.map(resp.data, brand => {
            return { id: brand.id, label: brand.id };
          });
        }
      });
    },
    changed(selectedValues) {
      this.$emit(
        'input',
        _.map(selectedValues, option => {
          return { group: '-', text: '-', value: option };
        })
      );
    },
  },
};
</script>

<style scoped></style>